import { useQuery } from 'react-query';
import { getDiseaseList } from '../api/getDiseaseList';
import { masterDataKeys, masterDataStaleTime } from '../api/queryKeys';

/**
 * Fetch disease master-data list (ICD-10).
 *
 * @param {Object} params - { search, page, limit, sort, isSearch }
 * @param {Object} [options]
 * @param {boolean} [options.enabled=true]
 */
export const useDiseaseList = (params, { enabled = true } = {}) => {
  const { data, isLoading, isError, refetch } = useQuery(
    masterDataKeys.diseases(params),
    ({ signal }) => getDiseaseList(params, signal),
    {
      enabled,
      staleTime: masterDataStaleTime.BATCH,
      keepPreviousData: true,
    }
  );

  return { data, isLoading, isError, refetch };
};

export default useDiseaseList;
